// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1Qw7C","footer":"Form_footer__rgkXp"};